module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-diferent-times-assignation/master-different-times-assignation.component.scss
// module id = ./src/app/master/master-diferent-times-assignation/master-different-times-assignation.component.scss
// module chunks = main